
export default {
  data () {
    return {
      loading: true,
      title: null,
      content: null
    }
  },
  mounted () {
    this.loadPage()
  },
  methods: {
    async loadPage () {
      try {
        const { data } = await this.$axios.$get(
          'api/front/pages/payments-method-modal'
        )

        this.loading = false
        this.content = data.content
      } catch (error) {
        console.error(error)
      }
    }
  }
}
